import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/common/store'
import pageModule from './store/pageModule'
import {EventBus} from '@/common/utils/event-bus'
import {PaginationPlugin, FormGroupPlugin, FormCheckboxPlugin, ButtonPlugin } from "bootstrap-vue";

import AddToCartButton from "@/common/components/cart/AddToCartButton.vue"
import Pagination from "./components/Pagination.vue"

import CatalogAPI from '@/common/api/eshop/shopping/catalog'
import SideBarApp from './SideBarApp.vue'

Vue.use(PaginationPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(ButtonPlugin);

Vue.use(VueRouter);

store.registerModule("pageModule", pageModule);
store.commit('pageModule/SET_PAGE_MODEL', window.page.model)

if (window.page.model.category && window.page.model.category.id) {
    store.commit('pageModule/SET_CATEGORY_FILTER', window.page.model.category.id)
}

if (window.page.model.category && window.page.model.category.id) {
    store.commit('pageModule/SET_CATEGORY_FILTER', window.page.model.category.id)
}


const router = new VueRouter({
    base: '',
    mode: 'history',
    linkActiveClass: 'open active',
    linkExactActiveClass: "exact-active",
})

let productList = mountProductList();
let productListPagination = mountProductListPagination();
let productListPaginationTop = mountProductListPaginationTop();
let productListSidebar = mountProductListSidebar();
let categoryQuickFilter = mountProductListQuickFilter();

EventBus.$on("product-filter", function ({append = false} = {}) {

    // let vProductListWrapEl = document.querySelector("#v-product-list")
    // vProductListWrapEl.classList.add("is-loading");
    store.commit("SHOW_LOADER", true);

    if (append === true) {
        store.commit('pageModule/PAGINATION_INCREMENT');
    }

    let query = store.getters['pageModule/filterQuery'];
    router.replace({query});

    CatalogAPI.getProducts({...query, requestType: 1})
        .then(response => {
            productList.$destroy();

            let template = response.data.result.template;
            let facets = response.data.result.facets;
            let total = response.data.result.total;

            store.commit('pageModule/SET_FACETS', facets);
            store.commit('pageModule/SET_PAGINATION_TOTAL', total)

            let productListEl = document.querySelector("#v-product-list--data")

            if (append === true) {
                productListEl.innerHTML += template
            } else {
                productListEl.innerHTML = template;
            }
            productList = mountProductList();
        }).then(() => {
        store.commit("SHOW_LOADER", false);
    });
});

function mountProductListSidebar() {
    new Vue({
        store,
        router,
        render: h => h(SideBarApp)
    }).$mount('#v-product-list-sidebar');
}

function mountProductListPagination() {
    return new Vue({
        router,
        components: {Pagination},
        computed: {
            totalProductCount() {
                return this.$store.state.pageModule.pagination.totalRows;
            },
            pageSize() {
                return this.$store.state.pageModule.pagination.perPage;
            },
            currentPage() {
                return this.$store.state.pageModule.pagination.currentPage;
            },
            showNextButton() {
                return this.totalProductCount > this.pageSize * this.currentPage
            }
        },
        created() {
            this.$on("get-next", () => {
                EventBus.$emit("product-filter", {append: true})
            })
        },
        el: '#v-product-list-pagination',
        store,
    });
}

function mountProductListPaginationTop() {
    return new Vue({
        router,
        computed: {
            totalProductCount() {
                return this.$store.state.pageModule.pageModel.pagination.totalRows;
            }
        },
        components: {Pagination},
        el: '#v-product-list-pagination-top',
        store,
    });
}

function mountProductList() {
 
        return new Vue({
            router,
            components: {AddToCartButton},
            el: ".v-product-list",
            store,
        }); 

}

function mountProductListQuickFilter() {
    return new Vue({
        router,
        el: '#v-category-quick-filter',
        store,
        data() {
            return {
                quickFilterSort: router.currentRoute.query.sort ?? null,
                quickFilterTags: router.currentRoute.query.tags != undefined ? router.currentRoute.query.tags.split(',') : []
            }
        },
        watch: {
            quickFilterSort: function (current, old) {
                this.$store.commit("pageModule/SET_SORT_FILTER", current);
            },
            quickFilterTags: function (current, old) {
                this.$store.commit("pageModule/SET_TAG_FILTER", current);
            }
        }
    });
}

//-------------------------------------------//

let catalogFilterBtn = document.getElementById("catalog-filter-btn");
let pageSidebar = document.getElementsByClassName("page-sidebar")[0];
let sidebarCloseBtn = document.getElementsByClassName("block-sidebar__close")[0];

if(catalogFilterBtn != null){
    catalogFilterBtn.addEventListener("click", () => {
        pageSidebar.classList.add("page-sidebar--open");
    });    
}

if(sidebarCloseBtn != null){
    sidebarCloseBtn.addEventListener("click", () => {
        pageSidebar.classList.remove("page-sidebar--open");
    });    
}


